module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmsbnp1-d91999a3323f67f6bfd2e8e96371870b.jpg";